import BaseModel from './base';

export const PAYMENT_METHOD_TYPE = {
	CARD: 'card', // Card will also enclose payment methods with wallets.
	PAYPAL: 'paypal',
	LINK: 'link'
};

export const PRICE_NAMES = {
	TRIAL: 'trial',
	MONTHLY: 'monthly',
	QUARTETLY: 'quarterly',
	YEARLY: 'yearly'
};

export const PAYMENT_STATUS = {
	PENDING: 'pending',
	PAID: 'paid',
	ERROR: 'error',
	CANCELED: 'canceled'
};

export const PAYMENT_TYPE = {
	REFUND: 'refund',
	PAYMENT: 'payment',
	DISPUTE: 'dispute'
};

class Payment extends BaseModel {
	/**
	 * Get currencies list
	 * */
	getCurrencies() {
		return this.get('/currencies');
	}

	/**
	 * Get all application prices.
	 */
	async getPrices({
		country,
		currency,
		filterActive = false,
		filterService = true
	} = {}) {
		const queryParams = new URLSearchParams();
		if (country) {
			queryParams.append('country', country);
		}
		if (currency) {
			queryParams.append('currency', currency);
		}

		const response = await this.get(`/prices?${queryParams.toString()}`, {
			completeResponse: true
		});

		const prices = await response.json();

		const { headers = {} } = response || {};

		let parsedPrices = prices;

		if (filterActive) {
			parsedPrices = parsedPrices.filter(price => price.active);
		}

		if (filterService) {
			parsedPrices = parsedPrices.filter(price => price.name !== 'service');
		}

		return { prices: parsedPrices, headers };
	}

	async getPayments({ params = {} }) {
		const queryParams = new URLSearchParams(params);

		const result = await this.get(`?${queryParams}`);

		return result;
	}

	getByHandlerId(handlerId) {
		return this.get(`/${handlerId}`);
	}

	addServiceSubscription(types = []) {
		return this.post('/service-charge', {
			body: { types }
		});
	}

	applyTrialDiscount() {
		return this.post('/apply-trial-discount');
	}
}

export default new Payment('/payment');
